module.exports = __webpack_public_path__ + "04_glasses_black.9e2ccf4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer4/04_glasses_black.png
// module id = CMzQ
// module chunks = 0